// extracted by mini-css-extract-plugin
export var downArrow = "_9i-0";
export var label = "_9i-1";
export var treatmentCard = "_9i-3";
export var upArrow = "_9i-2";